import styled from '@emotion/styled'
import { ReactNode } from 'react'
import Flex from 'shared/library/atoms/Flex'
import Icon, { IconNames } from 'shared/library/atoms/Icon'
import Spinner from 'library/atoms/Spinner'
import AnimatedIcon from 'shared/library/atoms/Icon/AnimatedIcon'
import { AnimatedIconNames } from 'enums/animatedIconNames'
import { defaultTheme } from 'assets/theme/theme'

interface NotifierContentActionsProps {
  children: ReactNode
}

export const NotifierContentActions = ({
  children
}: NotifierContentActionsProps) => (
  <StyledButtonFlex>{children}</StyledButtonFlex>
)

export interface NotifierContentProps {
  className?: string
  children?: ReactNode
  loading?: boolean
  staticIcon?: IconNames
  animatedIcon?: AnimatedIconNames
  iconColor?: keyof typeof defaultTheme.colors.icon
}

const NotifierContent = ({
  staticIcon,
  animatedIcon,
  children,
  className,
  loading,
  iconColor = 'primary'
}: NotifierContentProps) => (
  <Flex
    width={1}
    flexDirection="column"
    alignItems="center"
    className={className}
  >
    <StyledHeaderDiv />
    <StyledIconDiv>
      {loading && <Spinner />}
      {!loading && animatedIcon && (
        <AnimatedIcon name={animatedIcon} autoplay freezeOnLastFrame />
      )}
      {!loading && staticIcon && (
        <Icon name={staticIcon} size={16} color={iconColor} />
      )}
    </StyledIconDiv>
    {children && (
      <Flex
        flexDirection="column"
        alignItems="center"
        width={1}
        padding={5}
        paddingBottom={7}
      >
        {children}
      </Flex>
    )}
  </Flex>
)

const StyledHeaderDiv = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.background.primary,
  height: 80,
  width: '100%'
}))

const StyledIconDiv = styled.div(({ theme }) => ({
  height: theme.space[9],
  width: theme.space[9],
  marginTop: -theme.space[6],
  backgroundColor: theme.colors.white,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: theme.shadows[0],
  marginBottom: theme.space[2]
}))

const StyledButtonFlex = styled(Flex)(({ theme }) => ({
  paddingTop: theme.space[5],
  marginTop: theme.space[5],
  borderTop: theme.border,
  width: '100%',
  justifyContent: 'space-between'
}))

export default NotifierContent
